import { render, staticRenderFns } from "./PatientIndicate.vue?vue&type=template&id=613ab8f8&"
import script from "./PatientIndicate.vue?vue&type=script&lang=ts&"
export * from "./PatientIndicate.vue?vue&type=script&lang=ts&"
import style0 from "./PatientIndicate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports